import {Component, Input} from '@angular/core';
import {TileType50} from "../../../models";
import {
    ControlService,
    IconService,
    ParametersService,
    SubtitlesService,
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-controller-software',
    templateUrl: './tile-controller-software.component.html',
    styleUrls: ['./tile-controller-software.component.scss']
})
export class TileControllerSoftwareComponent {
    @Input() tile: TileType50;

    constructor(
        private control: ControlService,
        public icon: IconService,
        public parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }
}
